<template>
  <div>
    <v-snackbar
      v-model="showNotification"
      :timeout="timeout"
      :top="true"
      dark
      :color="color"
    >
      {{ notificationMsg }}
    </v-snackbar>
    <v-form
      class="px-3"
      ref="form"
      @submit.prevent="sendVerificationCode"
      v-if="!showPasswordForm"
    >
      <v-card flat outlined width="460" class="mx-auto my-10">
        <v-progress-linear
          class="mt-n1"
          indeterminate
          color="primary"
          v-if="loading"
        ></v-progress-linear>
        <div class="pa-4">
          <div class="ml-4 mt-2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" x-large to="/login">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
              </template>
              <span>Back to Login</span>
            </v-tooltip>
          </div>
          <div class="d-flex justify-center align-items-center mt-0">
            <v-img :src="require('@/assets/logo_org.png')" max-width="120">
            </v-img>
          </div>

          <v-card-title class="justify-center pt-6 mb-4 text-h5"
            >Reset your account password</v-card-title
          >
          <v-card-text class="text-body-1"
            >Please enter the email address used to create your Solva account. A
            verification code will be sent to allow you to change your
            password.</v-card-text
          >
          <v-card-text class="d-flex justify-center">
            <v-text-field
              v-model="email"
              prepend-icon="mdi-email"
              :rules="emailRules"
              style="max-width: 300px"
            >
              <template v-slot:label>
                Email
                <span class="red--text">*</span>
              </template>
            </v-text-field>
          </v-card-text>
          <div
            class="mb-4"
            style="
              width: 100%;
              max-width: 300px;
              margin-left: auto;
              margin-right: auto;
            "
          >
            <div :id="captchaId"></div>
          </div>
          <v-card-text class="d-flex align-items-center justify-center mb-4">
            <v-btn
              depressed
              color="primary"
              type="submit"
              :loading="loading"
              min-width="96px"
            >
              Send Verification Code
            </v-btn>
          </v-card-text>
          <!-- <v-divider></v-divider>

          <v-card-actions class="align-center">
            <v-btn
              text
              color="primary"
              router
              :to="'/login'"
              class="text-capitalize"
              >Login</v-btn
            >
          </v-card-actions> -->
        </div>
      </v-card>
    </v-form>
    <v-form
      class="px-3"
      ref="form2"
      @submit.prevent="changePassword"
      v-if="showPasswordForm"
    >
      <v-card flat outlined width="500" class="mx-auto my-10">
        <v-progress-linear
          class="mt-n1"
          indeterminate
          color="primary"
          v-if="loading"
        ></v-progress-linear>
        <div class="px-4 text-center">
          <div class="d-flex justify-center align-items-center mt-6">
            <v-img :src="require('@/assets/logo_org.png')" max-width="120">
            </v-img>
          </div>
          <v-card-title class="justify-center text-center pt-6 pb-6 text-5"
            >Reset your password</v-card-title
          >
          <div style="max-width: 400px; margin-left: auto; margin-right: auto">
            <v-card-text class="text-body-1 text-left pb-2"
              >Please enter the verification code sent to your email address.
            </v-card-text>
            <v-card-text class="align-items-center justify-center pt-0">
              <v-text-field
                v-model="verificationCode"
                type="text"
                prepend-icon="mdi-key-variant"
                required
                :rules="[
                  verificationCodeRules.exactlength,
                  verificationCodeRules.required,
                ]"
              >
                <template v-slot:label>
                  Verification Code
                  <span class="red--text">*</span>
                </template>
              </v-text-field>
              <v-text-field
                v-model="password"
                type="password"
                prepend-icon="mdi-lock"
                :rules="[passwordRules.required, passwordRules.minlength]"
              >
                <template v-slot:label>
                  New Password
                  <span class="red--text">*</span>
                </template>
              </v-text-field>

              <v-text-field
                v-model="confirmpassword"
                type="password"
                prepend-icon="mdi-lock"
                required
                :rules="repeatPasswordRules"
              >
                <template v-slot:label>
                  Confirm Password
                  <span class="red--text">*</span>
                </template>
              </v-text-field>
            </v-card-text>
          </div>
          <v-btn
            depressed
            color="primary"
            type="submit"
            :loading="loading"
            class="text-capitalize mt-2 mb-8"
          >
            Change Password
          </v-btn>
          <v-divider></v-divider>
          <v-card-text class="subtitle text-left"
            >Note: Please check your spam folder in case the email does not
            appear in your inbox.</v-card-text
          >
        </div>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import authService from "@/services/auth";

export default {
  name: "ResetPwd",
  data() {
    return {
      captchaId: "captcha-widget-reset-pwd",
      widget: null,
      email: "",
      password: "",
      confirmpassword: "",
      notificationMsg: "",
      loading: false,
      inputRules: [(v) => !!v || "This field is required"],
      passwordRules: {
        minlength: (v) =>
          (v && v.length >= 8) || "This field must have at least 8 characters",
        required: (v) => !!v || "This field is required",
      },
      verificationCodeRules: {
        exactlength: (v) => (v && v.length === 8) || "Invalid code",
        required: (v) => !!v || "This field is required",
      },
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      showNotification: false,
      timeout: 5000,
      y: "top",
      color: "orange",
      showPasswordForm: false,
      verificationCode: "",
    };
  },
  mounted() {
    this.intializeReCaptcha();
  },
  beforeUnmount() {
    const el = document.getElementById(this.captchaId);
    if (el) {
      el.remove();
    }
    this.resetCaptcha();
  },
  computed: {
    repeatPasswordRules() {
      return [
        (v) => !!v || "This field is required",
        (v) => (v && v.length >= 8) || "Minimum 8 characters",
        (v) => v === this.password || "Password does not match",
      ];
    },
  },
  methods: {
    resetCaptcha() {
      if (window.grecaptcha && window.grecaptcha.reset) {
        window.grecaptcha.reset(this.widget);
      }
    },
    captchaExpiredCallback() {
      if (window.grecaptcha) {
        this.resetCaptcha();
        this.intializeReCaptcha();
      }
    },
    intializeReCaptcha() {
      setTimeout(
        function () {
          if (
            typeof window.grecaptcha === "undefined" ||
            typeof window.grecaptcha.render === "undefined"
          ) {
            this.intializeReCaptcha();
          } else {
            this.widget = window.grecaptcha.render(this.captchaId, {
              sitekey: process.env.VUE_APP_CAPTCHA_SITE_KEY,
              "expired-callback": this.captchaExpiredCallback,
            });
          }
        }.bind(this),
        100
      );
    },
    sendVerificationCode() {
      if (this.$refs.form.validate()) {
        const captchaAlertMsg = "Please select the captcha.";
        const captcha = window.grecaptcha.getResponse(this.widget);
        if (captcha === "" || captcha === undefined || captcha === null) {
          alert(captchaAlertMsg);
          return;
        }
        this.loading = true;
        const payload = {
          email: this.email,
          captcha,
        };
        authService
          .initializePwdReset(payload)
          .then((res) => {
            this.color = "green";
            this.showNotification = true;
            this.loading = false;
            this.$refs.form.reset();
            this.email = payload.email;
            this.notificationMsg = res.data.message;
            this.showPasswordForm = true;
          })
          .catch((error) => {
            this.color = "red";
            this.notificationMsg = "An error occurred.";
            if (error.response) {
              const { data } = error.response;
              if (data.message) {
                this.notificationMsg = data.message;
              }
            }
            this.showNotification = true;
            this.loading = false;
          });
      }
    },
    changePassword() {
      if (this.$refs.form2.validate()) {
        const payload = {
          email: this.email,
          code: this.verificationCode,
          password: this.password,
        };
        this.loading = true;
        authService
          .changePassword(payload)
          .then((res) => {
            if (res.data && res.data.success === true && res.data.message) {
              this.color = "green";
              this.notificationMsg = res.data.message;
              this.showNotification = true;
            }
            this.$refs.form2.reset();
            this.showPasswordForm = false;
            setTimeout(() => {
              this.showNotification = false;
              this.notificationMsg = "Redirecting to login page...";
              this.showNotification = true;
              this.loading = false;
              setTimeout(() => {
                this.$router.push("/login");
              }, 4000);
            }, 2000);
          })
          .catch((error) => {
            this.color = "red";
            this.notificationMsg =
              "An error occured while changing your password.";
            if (error.response) {
              const { data } = error.response;
              if (data.message) {
                this.notificationMsg = data.message;
              }
            }
            this.showNotification = true;
            this.loading = false;
          });
      }
    },
  },
};
</script>
<style>
.container {
  padding: 0 !important;
}
.v-dialog {
  overflow-x: hidden !important;
}
</style>